import type { ReactElement } from 'react'

import { FlowPage } from '@monthio/design-system'
import { useTranslation } from 'react-i18next'

export const FinishButtonSection = ({
	shouldUseBudgetHelper,
	onClick,
}: {
	shouldUseBudgetHelper?: boolean
	onClick?: (event: any) => void
}): ReactElement => {
	const { t } = useTranslation()

	return (
		<FlowPage.Cta onClick={onClick}>
			{shouldUseBudgetHelper
				? t('budgetHelper-miniBudgetForm-finishButtonSection-button')
				: t('miniBudgetForm-finishButtonSection-button')}
		</FlowPage.Cta>
	)
}
